import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-asbmcsyllabus',
    templateUrl: './asbmcsyllabus.component.html',
    styleUrls: ['./asbmcsyllabus.component.scss']
})
export class AsbmcsyllabusComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
